// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body.onboarding-section #fuse-navbar {\n  display: none !important;\n}\n\nbody.onboarding-section.new #fuse-navbar {\n  display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
